import { InteractiveElement } from "@iventis/styles";
import React, { ReactNode } from "react";
import { StyledPopover } from "@iventis/components";
import { SimpleTooltip } from "@iventis/components/src/tooltips";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { OverflowOption, TreeBrowserNode } from "../../../types/data-types";

export function LibraryOverflowPopover<TNode extends TreeBrowserNode, TLabel extends string | ReactNode = string>({
    overflowOpen,
    setOverflowOpen,
    overflowOptions,
    overflowButtonRef,
    node,
    withIcons = false,
}: {
    overflowOpen: boolean;
    setOverflowOpen: (bool: boolean) => void;
    overflowOptions: OverflowOption<TNode, TLabel>[];
    overflowButtonRef: React.RefObject<HTMLElement>;
    node: TNode;
    withIcons?: boolean;
}) {
    const translate = useIventisTranslate();
    return (
        <StyledPopover
            space={44}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={overflowOpen}
            anchorEl={overflowButtonRef.current}
            onClose={() => {
                setOverflowOpen(false);
            }}
            $withIcons={withIcons}
            data-testid="library-node-overflow-popover"
        >
            {overflowOptions.map(({ label, selected, key, disabled }) => (
                <div key={key ?? label.toString()}>
                    <SimpleTooltip text={translate(Content.library2.delete_node.selected_items_cannot_be_deleted)} disabled={!disabled} placement="left">
                        <InteractiveElement
                            data-testid={`overflow-button-${label}`}
                            className="button"
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                setOverflowOpen(false);
                                selected(node);
                            }}
                            disabled={disabled ?? false}
                        >
                            {label}
                        </InteractiveElement>
                    </SimpleTooltip>
                </div>
            ))}
        </StyledPopover>
    );
}
